var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppetizer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_224)",
    filter: "url(#filter0_d_641_224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 8.01562C21.7089 8.01562 21.4727 8.25183 21.4727 8.54297V15.062C21.4727 15.3534 21.7089 15.5893 22 15.5893C22.2911 15.5893 22.5273 15.3534 22.5273 15.062V8.54297C22.5273 8.25183 22.2911 8.01562 22 8.01562Z",
    fill: "#594F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5254 8.01562C13.2343 8.01562 12.998 8.25183 12.998 8.54297V15.062C12.998 15.3534 13.2343 15.5893 13.5254 15.5893C13.8165 15.5893 14.0527 15.3534 14.0527 15.062V8.54297C14.0527 8.25183 13.8165 8.01562 13.5254 8.01562Z",
    fill: "#594F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4746 8.01562C30.1835 8.01562 29.9473 8.25183 29.9473 8.54297V15.062C29.9473 15.3534 30.1835 15.5893 30.4746 15.5893C30.7657 15.5893 31.002 15.3534 31.002 15.062V8.54297C31.002 8.25183 30.7657 8.01562 30.4746 8.01562Z",
    fill: "#594F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4941 23.7292H20.5059C19.6808 23.7292 19.0117 23.0602 19.0117 22.2351V19.2468C19.0117 18.4215 19.6808 17.7527 20.5059 17.7527H23.4941C24.3192 17.7527 24.9883 18.4215 24.9883 19.2468V22.2351C24.9883 23.0602 24.3192 23.7292 23.4941 23.7292Z",
    fill: "#FFD659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4948 17.7527H21.2539C22.079 17.7527 22.748 18.4215 22.748 19.2468V22.2351C22.748 23.0602 22.079 23.7292 21.2539 23.7292H23.4948C24.3199 23.7292 24.989 23.0602 24.989 22.2351V19.2468C24.989 18.4215 24.3199 17.7527 23.4948 17.7527Z",
    fill: "#FFBD54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8982 14.946C24.8982 16.5461 23.601 17.8433 22.0009 17.8433C20.4007 17.8433 19.1035 16.5461 19.1035 14.946C19.1035 13.3458 20.4007 12.0486 22.0009 12.0486C23.601 12.0486 24.8982 13.3458 24.8982 14.946Z",
    fill: "#FF2C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 12.0486C21.6161 12.0486 21.2494 12.1241 20.9141 12.2601C21.9756 12.6899 22.7249 13.7303 22.7249 14.946C22.7249 16.1619 21.9756 17.2023 20.9141 17.6321C21.2494 17.7678 21.6161 17.8433 22.0003 17.8433C23.6005 17.8433 24.8977 16.5461 24.8977 14.946C24.8977 13.3458 23.6005 12.0486 22.0003 12.0486Z",
    fill: "#E62753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 23.7292H12.0312C11.2062 23.7292 10.5371 23.0602 10.5371 22.2351V19.2468C10.5371 18.4215 11.2062 17.7527 12.0312 17.7527H15.0195C15.8446 17.7527 16.5137 18.4215 16.5137 19.2468V22.2351C16.5137 23.0602 15.8446 23.7292 15.0195 23.7292Z",
    fill: "#FFD659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0183 17.7527H12.7773C13.6027 17.7527 14.2715 18.4215 14.2715 19.2468V22.2351C14.2715 23.0602 13.6027 23.7292 12.7773 23.7292H15.0183C15.8433 23.7292 16.5124 23.0602 16.5124 22.2351V19.2468C16.5124 18.4215 15.8433 17.7527 15.0183 17.7527Z",
    fill: "#FFBD54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4217 14.946C16.4217 16.5461 15.1245 17.8433 13.5243 17.8433C11.9242 17.8433 10.627 16.5461 10.627 14.946C10.627 13.3458 11.9242 12.0486 13.5243 12.0486C15.1245 12.0486 16.4217 13.3458 16.4217 14.946Z",
    fill: "#FF2C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5257 12.0486C13.1415 12.0486 12.7748 12.1241 12.4395 12.2601C13.501 12.6899 14.2503 13.7303 14.2503 14.946C14.2503 16.1619 13.501 17.2023 12.4395 17.6321C12.7748 17.7678 13.1415 17.8433 13.5257 17.8433C15.1259 17.8433 16.4231 16.5461 16.4231 14.946C16.4231 13.3458 15.1259 12.0486 13.5257 12.0486Z",
    fill: "#E62753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9687 23.7292H28.9805C28.1554 23.7292 27.4863 23.0602 27.4863 22.2351V19.2468C27.4863 18.4215 28.1554 17.7527 28.9805 17.7527H31.9687C32.7938 17.7527 33.4629 18.4215 33.4629 19.2468V22.2351C33.4629 23.0602 32.7938 23.7292 31.9687 23.7292Z",
    fill: "#FFD659"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9694 17.7527H29.7285C30.5536 17.7527 31.2227 18.4215 31.2227 19.2468V22.2351C31.2227 23.0602 30.5536 23.7292 29.7285 23.7292H31.9694C32.7945 23.7292 33.4636 23.0602 33.4636 22.2351V19.2468C33.4636 18.4215 32.7945 17.7527 31.9694 17.7527Z",
    fill: "#FFBD54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3729 14.946C33.3729 16.5461 32.0756 17.8433 30.4755 17.8433C28.8753 17.8433 27.5781 16.5461 27.5781 14.946C27.5781 13.3458 28.8753 12.0486 30.4755 12.0486C32.0756 12.0486 33.3729 13.3458 33.3729 14.946Z",
    fill: "#FF2C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4752 12.0486C30.091 12.0486 29.7243 12.1241 29.3887 12.2601C30.4505 12.6899 31.1998 13.7303 31.1998 14.946C31.1998 16.1619 30.4505 17.2023 29.3887 17.6321C29.7243 17.7678 30.091 17.8433 30.4752 17.8433C32.0754 17.8433 33.3726 16.5461 33.3726 14.946C33.3726 13.3458 32.0754 12.0486 30.4752 12.0486Z",
    fill: "#E62753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6758 27.9845H9.32382C8.52374 27.9845 7.875 27.336 7.875 26.5359V24.7249H36.1246V26.5359C36.1246 27.336 35.4759 27.9845 34.6758 27.9845Z",
    fill: "#D1C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9134 25.8112H5.08655C4.48642 25.8112 4 25.3248 4 24.7247C4 24.1248 4.48642 23.6384 5.08655 23.6384H38.9134C39.5135 23.6384 39.9999 24.1248 39.9999 24.7247C39.9999 25.3248 39.5135 25.8112 38.9134 25.8112Z",
    fill: "#EBE4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9131 23.6384H36.7402C37.3404 23.6384 37.8268 24.1248 37.8268 24.7247C37.8268 25.3248 37.3404 25.8112 36.7402 25.8112H38.9131C39.5132 25.8112 39.9996 25.3248 39.9996 24.7247C39.9996 24.1248 39.5132 23.6384 38.9131 23.6384Z",
    fill: "#D1C4C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_641_224",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_641_224"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_641_224",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppetizer);
export default __webpack_public_path__ + "static/media/appetizer.e6b793136d98f16d2d1f4354d688b481.svg";
export { ForwardRef as ReactComponent };